import { ArrowLeft, ArrowRight } from "lucide-react"

type LessonPagerProps = {
  current: number
  total: number
  hasPrevious: boolean
  hasNext: boolean
  /** La siguiente existe pero aún no está disponible para el estudiante. */
  nextBlocked: boolean
  onPrevious: () => void
  onNext: () => void
}

const buttonClass =
  "inline-flex min-h-11 items-center gap-2 rounded-lg border border-border bg-foreground/5 px-4 text-sm font-semibold text-foreground outline-none transition-colors hover:bg-foreground/10 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-foreground/5"

/** Barra delgada bajo el reproductor: anterior · posición · siguiente. */
export default function LessonPager({
  current,
  total,
  hasPrevious,
  hasNext,
  nextBlocked,
  onPrevious,
  onNext,
}: LessonPagerProps) {
  const nextHint = nextBlocked ? "Disponible al aprobar la lección anterior" : "Esta es la última lección"

  return (
    <nav aria-label="Navegación entre lecciones" className="mt-3 flex items-center justify-between gap-3">
      <button
        type="button"
        onClick={onPrevious}
        disabled={!hasPrevious}
        title={hasPrevious ? undefined : "Esta es la primera lección"}
        className={`${buttonClass} motion-press`}
      >
        <ArrowLeft className="h-4 w-4" aria-hidden="true" />
        <span>Anterior</span>
      </button>

      <p className="text-center text-xs font-medium tabular-nums text-muted-foreground">
        Lección {current} de {total}
      </p>

      <button
        type="button"
        onClick={onNext}
        disabled={!hasNext}
        title={hasNext ? undefined : nextHint}
        aria-label={hasNext ? "Siguiente lección" : `Siguiente lección. ${nextHint}`}
        className={`${buttonClass} motion-press motion-link-arrow`}
      >
        <span>Siguiente</span>
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </button>
    </nav>
  )
}
